import React, { Component } from 'react';
import { render } from 'react-dom';
import TabsWizard from './Components/TabsWizard.js'
import LogIn from './Components/ApplicantLogIn.js';
import LogInWhenInterested from './Components/ApplicantWhenInterestedLogIn.js';
import { applyFreeTabs } from './Components/ApplyFreeTabs.js'
import { applyJobTabs } from './Components/ApplyJobTabs.js'
import { applyBusinessTabs } from './Components/ApplyBusinessTabs'
import { checkAuthentication, postJob } from './Api/UserActions'
import { getJobDetail } from './Api/Jobs.js';
import { registerIndeed } from './Utilities/SnsFunctions.js';

import Loading from './Components/Loading.js';

declare var globalSns;

class AppApplicant extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.onLoginSucceeded = this.onLoginSucceeded.bind(this);
        this.onRegisterRequest = this.onRegisterRequest.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        checkAuthentication((isAuthenticated) => {
            this.setState({
                skipCredentials: globalSns.newMember ? true : isAuthenticated
            })

            if (globalSns.newMember || isAuthenticated) {
                this.loadJobData(isAuthenticated);
            }
        });
    }

    loadJobData(authenticated) {
        getJobDetail(globalSns.jobId, globalSns.languageId, (data) => {
            this.loadJobBreadCrumb(data);
            this.setState({
                job: data,
                authenticated: authenticated
            });
        });
    }

    loadJobBreadCrumb(job) {

        const breadcrumbContainer = document.querySelector("#breadcrumbs");

        let title = job.title;

        if (job.organisation.id > 0)
            title += " - " + job.organisation.name;

        render(
            <div>
                <a href={globalSns.myHomepageUrl} className="CMSBreadCrumbsLink">{globalSns.myHomepageName}</a>
                &nbsp;<span className="sep">&gt;</span>&nbsp;
                <a href={"/" + globalSns.cultureAlias + "/applications"} className="CMSBreadCrumbsLink">{globalSns.applicationsName}</a>
                &nbsp;<span className="sep">&gt;</span>&nbsp;
                <span className="CMSBreadCrumbsCurrentItem">{title}</span>
            </div>
            , breadcrumbContainer
        );
    }

    registerJob() {
        postJob(globalSns.jobId, (globalSns.mediumId == null) ? null : globalSns.jobSiteId , globalSns.mediumId, () => {
            registerIndeed();
        });
    }

    onLoginSucceeded() {
        this.registerJob();
        this.loadData(); // reload
    }

    onRegisterRequest() {
        this.setState({
            skipCredentials: true
        });
        this.loadJobData(false);
    }

    render() {
        // Is the user already authenticated ?
        if (this.state.skipCredentials != null && this.state.skipCredentials === false) {
            
            if (globalSns.allowAsGuest) {

                getJobDetail(globalSns.jobId, globalSns.languageId, (data) => {
                    if (data != null) {
                        this.loadJobBreadCrumb(data);
                    }
                });

                return (
                  <div className="login">
                      <LogInWhenInterested onLoginSucceeded={this.onLoginSucceeded} onRegisterRequest={this.onRegisterRequest} />
                  </div>
                );
            }

            return (
                <div className="login">
                    <LogIn onLoginSucceeded={this.onLoginSucceeded} onRegisterRequest={this.onRegisterRequest} />
                </div>
            );
        }

        // Load Tab Wizard
        if (this.state.job == null) {
            return (
                <Loading />
            );
        }

        var steps = applyFreeTabs;
        var finishUrl = globalSns.jobFreeFinishUrl;

        if (this.state.job.isBusinessRegistration) {
            steps = applyBusinessTabs;
            finishUrl = globalSns.registrantFinishUrl;
        } else if (globalSns.jobId > 0) {
            steps = applyJobTabs;
            finishUrl = globalSns.jobFinishUrl;
        }

        return (
            <TabsWizard steps={steps} finishUrl={finishUrl} job={this.state.job} authenticated={this.state.authenticated} overview={globalSns.step === "overview"} />
        );
    }
}

export default AppApplicant;



// WEBPACK FOOTER //
// ./src/AppApplicant.js